import { createContext, useContext } from "react";
import { Menu, Sidebar } from "semantic-ui-react";
import BmpGeneral from "../models/BmpGeneral";

export interface ISidebarComponent {
    children: any;
    sidebarName: string;
    screenSize: number;
    screenDisplayType: string;
    isSpreadingGrounds?: boolean;
}

export type SidebarTypes =
    | "Home"
    | "Project Details"
    | "Filter"
    | "Reporting"
    | "Welcome"
    | "Close"
    | "Reports"
    | "LogOff"
    | "PrettyProjectPage"
    | "EditProjectPage";

export type SidebarManagerAction = {
    type: "open" | "close" | "toggle" | "reset";
    payload?: { name: SidebarTypes; content: any };
};

export type SidebarManagerState = {
    current: { name: SidebarTypes; content: any };
    previous: { name: SidebarTypes; content: any };
};

export const SidebarContext = createContext<{
    sidebarStore: SidebarManagerState,
    dispatchSidebar: (action: SidebarManagerAction) => void,
    sidebarProjectInfoObj: BmpGeneral,
    setSidebarProjectInfoObj: (project: BmpGeneral) => void,
    sidebarVisible: boolean,
    setSidebarVisible: (v: boolean) => void
}>({
    sidebarStore: {
        current: { name: "Reports" as SidebarTypes, content: null },
        previous: { name: "Welcome" as SidebarTypes, content: null },
    },
    dispatchSidebar: function(): void {
        throw new Error("Function not implemented.");
    },
    sidebarProjectInfoObj: new BmpGeneral(),
    setSidebarProjectInfoObj: function(): void {
        throw new Error("Function not implemented.");
    },
    sidebarVisible: false,
    setSidebarVisible: function(): void {
        throw new Error("Function not implemented.");
    }
});

export const SidebarComponent = (props: ISidebarComponent) => {

    const { sidebarStore } = useContext(SidebarContext);

    const getWidth = () => {
        let width: string;

        // if name is EditProjectPage
        if (sidebarStore.current.name === "EditProjectPage") {
            width = props.screenDisplayType === "desktop" ? "75%" : "100%";

            // if any other page on desktop
        } else if (props.screenDisplayType === "desktop") {
            width = props.isSpreadingGrounds ? "400px" : "330px"

            // if mobile
        } else {
            width = "100%";
        }
        return width;
    };

    return (
        <div>
            <div className="generic-sidebar-wrapper">
                <Sidebar
                    as={Menu}
                    animation="overlay"
                    icon="labeled"
                    inverted
                    vertical
                    visible={
                        sidebarStore?.current.name === props.sidebarName
                            ? true
                            : false
                    }
                    style={{ width: getWidth() }}
                    className="generic-sidebar"
                >
                    {props.children}
                </Sidebar>
            </div>
        </div>
    );
};
